module.exports = __webpack_public_path__ + "static/img/26-人大附中朝阳分校东坝校区.91f2f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/26-人大附中朝阳分校东坝校区.png
// module id = CvWi
// module chunks = 0